<template>
  <b-form-group
    label="Durum (M)"
    label-for="is_receipt"
  >
    <v-select
      id="is_receipt"
      v-model="filterParams.receipt_status"
      :options="receiptStatuses"
      label="title"
      :reduce="item => item.value"
      placeholder="Tümü"
    />
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'

export default {
  name: 'ReceiptStatus',
  components: {
    BFormGroup,
    vSelect,
  },
  data() {
    return {
      receiptStatuses: [
        { title: 'Tümü', value: 'all' },
        { title: 'Var', value: '1' },
        { title: 'Yok', value: '0' },
      ],
    }
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
}
</script>
